<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('q58')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
 
    <div class="main">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :pulling-text="$t('index.loading')"
        :loosing-text="$t('index.loading')"
        :loading-text="$t('index.loading')"
      >
        <van-loading v-if="loading" type="spinner" vertical>{{$t("index.loading")}}</van-loading>
        <van-empty v-else-if="!loading && list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="record-list">
          <div class="record-item" v-for="(item, index) in list" :key="index">
            <div class="record-header">
              <div class="left-info">
                <span class="order-id">{{ item.order_id }}</span>
                <span class="status" :class="{'status-success': item.status === 1}">
                  {{ item.status === 1 ? $t('setting.ok') : $t('setting.cancel') }}
                </span>
              </div>
              <div class="amount" :class="{'amount-success': item.status === 1}">
                {{ formatMoney(item.money) }}
              </div>
            </div>
            <div class="record-body">
              <div class="time">
                <van-icon name="clock-o" />
                <span>{{ item.create_time }}</span>
              </div>
              <div class="payment-method" v-if="item.pay_type">
                <van-icon name="credit-pay" />
                <span>{{ item.pay_type }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      loading: true,
      list: []
    };
  },
  methods: {
    formatMoney(money) {
      if (!money) return '0';
      return Math.floor(parseFloat(money)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    back(){
      return window.history.back();
    },
    onRefresh() {
      this.getRechargeList();
    },
    getRechargeList(){
      this.loading = true;
      this.$http({
        method: 'get',
        url: 'recharge_list'
      }).then(res => {
        this.loading = false;
        this.isLoading = false;
       
        if(res.code === 200){
          this.list = res.data || [];
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      }).catch(err => {
        this.loading = false;
        this.isLoading = false;
        console.error('获取充值记录失败:', err);
        this.$toast(this.$t('withdraw.empty_data'));
      });
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getRechargeList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.main {
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 15px;
}

.record-list {
  .record-item {
    background: linear-gradient(120deg, #212121, #313131);
    border-radius: 15px;
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #766350;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease;

    &:active {
      transform: scale(0.98);
    }

    .record-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      
      .left-info {
        display: flex;
        align-items: center;
        gap: 12px;
        
        .order-id {
          color: #f3c7a2;
          font-size: 28px;
          font-weight: 600;
        }
        
        .status {
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 24px;
          background: rgba(255, 255, 255, 0.1);
          color: #999;
          
          &.status-success {
            background: rgba(7, 193, 96, 0.1);
            color: #07c160;
          }
        }
      }
      
      .amount {
        color: #f3c7a2;
        font-size: 32px;
        font-weight: bold;
        
        &.amount-success {
          color: #07c160;
        }
      }
    }

    .record-body {
      display: flex;
      flex-direction: column;
      gap: 12px;
      
      .time, .payment-method {
        display: flex;
        align-items: center;
        color: #999;
        font-size: 24px;
        
        .van-icon {
          margin-right: 8px;
          font-size: 24px;
        }
      }
    }
  }
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #f3c7a2;
  font-size: 28px;
}

::v-deep .van-loading__text {
  color: #f3c7a2;
  font-size: 28px;
}

::v-deep .van-nav-bar {
  background-color: #1f1c1f;
  
  .van-nav-bar__title {
    color: #f3c7a2;
    font-size: 32px;
  }
}

::v-deep .van-empty__description {
  color: #f3c7a2;
  font-size: 28px;
}
</style>
